<template>
    <div class="p-3">
        <b-card
            title="Edit Pengguna"
        >
            <b-card-text>
                <form class="mt-5">
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="input-nama">Nama</label>
                        <div class="col-lg-6">
                            <input type="text" v-model="form.name" class="form-control" id="input-nama">
                        </div>
                    </div>

                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="input-useername">Username</label>
                        <div class="col-lg-6">
                            <input type="text" v-model="form.username" class="form-control" id="input-useername">
                        </div>
                    </div>

                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="input-password">Password</label>
                        <div class="col-lg-6">
                            <input type="password" v-model="form.password" class="form-control" id="input-password">
                            <span class="help-block text-primary">Diisi Jika Ingin Mengganti Password</span>
                        </div>
                    </div>

                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="input-akses-level">Akses Level</label>
                        <div class="col-lg-6">
                            <input type="text" v-model="form.akses_level" class="form-control" id="input-akses-level">
                        </div>
                    </div>

                    <div class="form-group row pb-4">
                        <div class="col-lg-3 text-lg-end pt-2"></div>
                        <div class="col-lg-6">
                            <b-button class="btn-sm" variant="primary" @click="updateUser">Simpan</b-button>
                            <b-button class="btn-sm" @click="cancelEdit">Batal</b-button>
                        </div>
                    </div>
                </form>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
export default {
    props: ['id'],
    data() {
        return {
            user: null,
            form: {
                name: null,
                username: null,
                password: null,
                akses_level: null,
            }
        }
    },
    created() {
        this.getAuth()
    },
    methods: {
        getAuth() {
            this.user = localStorage.getItem('user')
            this.access_token = localStorage.getItem('access_token')

            this.getUser()
        },
        getUser() {
            this.$isLoading(true)
            let uri = '/api/users/' + this.id

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.get(uri, headers).then(response => {
                if (response.data.status == 'success') {
                    this.user = response.data.user

                    this.form.name = response.data.user.name
                    this.form.username = response.data.user.username
                    this.form.akses_level = response.data.user.akses_level ? response.data.user.akses_level.akses_level : '-'
                } else {
                    alert('User not found!')
                }
                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        updateUser() {
            this.$isLoading(true)
            let uri = '/api/users/' + this.id

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.put(uri, this.form, headers).then(response => {
                if (response.data.status == 'success') {
                    alert('Data berhasil disimpan!')
                    this.$router.push({ name: 'konfigurasi_user' }).catch(()=>{})
                } else {
                    alert(response.data.message)
                }
                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        cancelEdit() {
            this.$router.push('konfigurasi-user')
        }
    }
}
</script>
